<template>
	<div class="share-group">
		<div
			class="share shadow-box flex-center"
			@click="openSharePanel()"
		>
			<i class="fas fa-share-alt"></i>
		</div>
		<transition name="modal-on">
			<div
				class="panel"
				v-if="panelActive"
			>	
				<!-- <div class="triangle-outer"></div>
				<div class="triangle-inner"></div> -->
				<slot></slot>
			</div>
		</transition>
	</div>
</template>

<script type="text/javascript">
	import SocialShare from './SocialShare'

	export default {
		data () {
			return {
				panelActive: false,
				url: location.href
			}
		},

		components: {
			SocialShare
		},

		methods: {
			openSharePanel () {
				this.panelActive = !this.panelActive
			}
		}
	}
</script>

<style type="text/css" scoped>
	
	.fas {
		font-size: 14px;
		cursor: pointer;
	}

	.share {
		margin-bottom: 10px;
		color: white;
		background: white;
		border-radius: 50%;
		width: 30px;
		height: 30px;
		color: grey;
	}

	.panel {
		position: relative;
		
	}

	.share-group >>> .panel{
		background-color: white;
		padding: 5px;
		border-radius: 6px;
	}

	.share-group {
		position: relative;
		display: flex;
		flex-direction: column;
		align-items: flex-end;
	}

	.triangle-outer,
	.triangle-inner  {
		position: absolute;
		top: -10px;
		right: 10px;
		border-left: 10px solid transparent;
		border-right: 10px solid transparent;
	}

	.triangle-outer {
		border-bottom: 10px solid var(--quomi-ligthgrey-hover);
	}

	.triangle-inner {
		border-bottom: 11px solid white;
	}
</style>